import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';
import { AuthService } from '../services/auth.service';
import { TokenService } from '../services/token.service';
import { UserService } from '../services/user.service';
import { ValidationService } from '../services/validation.service';
import { StrategiesPermissionsService } from '../../strategies/services/strategies-permissions.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {
  static readonly  FORCED_LOGOUT_PARAM = 'forced-logout';
  static readonly INVALID_CREDENTIALS_PARAM = 'invalid-credentials';
  loginForm: FormGroup;
  displayModal: boolean;
  agreeToTerms = true;
  loginFormErrMsg: string;
  myJourneyUrl = environment.my_journey_url;

  constructor(private route: ActivatedRoute, private router: Router, private formBuilder: FormBuilder, private authService: AuthService,
              private tokenService: TokenService, private userService: UserService, private validationService: ValidationService,
              private strategiesPermissionsService: StrategiesPermissionsService) {
    this.loginForm = this.formBuilder.group({
      email: ['', [this.validationService.emailValidator, this.validationService.spaceChecker]],
      password: ['', [this.validationService.passwordValidator, this.validationService.spaceChecker]]
    });
  }

  ngOnInit() {
    this.strategiesPermissionsService.clearRoleAndPermissions();
    this.route.queryParams
      .subscribe(params => {
        if (params.error === LoginComponent.INVALID_CREDENTIALS_PARAM) {
          this.loginFormErrMsg = 'Please enter a valid email address and password.';
        } else if (params.error === LoginComponent.FORCED_LOGOUT_PARAM) {
          this.loginFormErrMsg = 'You have been logged out. Please enter a valid email address and password.';
        }
      });
  }

  errMsgOff(event): void {
    this.loginFormErrMsg = event.key !== 'Enter' ? null : this.loginFormErrMsg;
  }

  login(): void {
    this.loginForm.controls.email.markAsTouched();
    this.loginForm.controls.password.markAsTouched();
    if (this.loginForm.valid) {
      this.authService.login(this.loginForm.value).subscribe(
        res => {
          this.loginFormErrMsg = null;
          this.tokenService.token = res.token;
          this.userService.user = res.user;
          const user = this.userService.user;
          this.strategiesPermissionsService.populateSuperAdminRoleAndPermissions();
          if (!user.isStrategiesUser()) {
            this.loginFormErrMsg = 'User profile has no institution associated';
          } else if (!user.acceptTandC) {
            this.displayModal = true;
          } else {
            this.router.navigate(['/select-institution']);
          }
        },
        err => {
          if (err.error.errorCode === 'INVALID_CREDENTIALS') {
            this.loginFormErrMsg = 'Please enter a valid email address and password.';
          } else if (err.error.errorCode === 'NO_ASSOCIATED_INSTITUTIONS') {
            this.loginFormErrMsg = 'User profile has no institution associated.';
          }
        });
    }
  }

  acceptTerms(): void {
    this.displayModal = false;
    this.authService.acceptTerms().subscribe(
      () => {
        this.router.navigate(['/select-institution']);
      },
      () => {
        // TODO handle login error
      });
  }

  declineTerms(): void {
    this.displayModal = false;
    this.loginFormErrMsg = 'You must accept the Terms & Conditions to login.';
    console.log('CLEARING LOCAL STORAGE - 6');
    localStorage.clear();
  }
}
